export class UploadItem {
  row_no: number
  file_name: string
  paper_qr_code: string
  student_qr_code: string
  sheet_code: string
  sheet_name: string
  cram_student_id: number
  student_code: number
  cram_code: number
  student_name: string
  course_code: number
  room_code: number
  room_name: string
  class_code: number
  class_name: string
  level: string
  curriculum_id: number
  dpi: number
  width: number
  height: number
  angle: number = 0
  errors: string[]
  base_width: number
  base_height: number
  hosei_positions: number[][] = [];
  base_hosei_positions: number[][] = [];

  constructor(item: any){
    this.row_no = item.row_no;
    this.file_name = item.file_name;
    this.paper_qr_code = item.paper_qr_code;
    this.student_qr_code = item.student_qr_code;
    this.sheet_code = item.sheet_code;
    this.sheet_name = item.sheet_name;
    this.cram_student_id = item.cram_student_id;
    this.student_code = item.student_code;
    this.cram_code = item.cram_code;
    this.student_name = item.student_name;
    this.course_code = item.course_code;
    this.room_code = item.room_code;
    this.room_name = item.room_name;
    this.class_code = item.class_code;
    this.class_name = item.class_name;
    this.level = item.level;
    this.curriculum_id = item.curriculum_id;
    this.dpi = item.dpi;
    this.width = item.width;
    this.height = item.height;
    this.errors = item.errors;
    this.base_width = item.base_width;
    this.base_height = item.base_height;
    this.angle = item.rotate_angle;

    if(item.hosei_positions != null){
      this.hosei_positions = item.hosei_positions;

      if(this.angle == 90){
        this.hosei_positions = rotateHoseiPosition(this.hosei_positions, DirectionEnum.Right, this.angle, this.width, this.height);
      }

      if(this.angle == 270){
        this.hosei_positions = rotateHoseiPosition(this.hosei_positions, DirectionEnum.Left, this.angle, this.width, this.height);
      }      
    }

    if(item.base_hosei_positions != null){
      this.base_hosei_positions = item.base_hosei_positions;
    }
  }
}

export class ImageItem {
  fileName: string
  base64Image: string

  constructor(fileName: string, base64Image: string){
    this.fileName = fileName;
    this.base64Image = base64Image;
  }
}

export class SearchCondition {
  student_code: string = ""
  cram_code: string = ""
  name: string = ""
  nendo: string = ""
  grade: string = ""
  room_code: string = ""
  room_name: string = ""
  class_code: string = ""
  class_name: string = ""
  course_code: string = ""
  course_name: string = ""
  course_type: string = ""
}

export interface CramStudent {
  id: number
  student_code: number
  cram_code: number
  name: string
  nendo: number
  grade: number
  room_code_1: number
  room_name_1: string
  class_code_1: number
  class_name_1: string
  course_code_1: number
  course_name_1: string
  course_type_1: number
  level_1: string
  room_code_2: number
  room_name_2: string
  class_code_2: number
  class_name_2: string
  course_code_2: number
  course_name_2: string
  course_type_2: number
  level_2: string
  room_code_3: number
  room_name_3: string
  class_code_3: number
  class_name_3: string
  course_code_3: number
  course_name_3: string
  course_type_3: number
  level_3: string
  room_code_4: number
  room_name_4: string
  class_code_4: number
  class_name_4: string
  course_code_4: number
  course_name_4: string
  course_type_4: number
  level_4: string
  full_count: number
}

export const DirectionEnum = Object.freeze({Left: 1, Right: 2});

export const rotateHoseiPosition = (hosei_positions: number[][], direction: number, angle: number, imageW: number, imageH: number) => {

  const newHoseiPositions: number[][] = [[-1, -1], [-1, -1], [-1, -1], [-1, -1]];

  const width = angle == 90 || angle == 270 ? imageW : imageH;
  const height = angle == 90 || angle == 270 ? imageH : imageW;

  hosei_positions.forEach((pos, i) => {
    if(direction == DirectionEnum.Left){
      if(i == 0){
        newHoseiPositions[1][0] = pos[1];
        newHoseiPositions[1][1] = width - pos[0];
      }else if(i == 1){
        newHoseiPositions[2][0] = pos[1];
        newHoseiPositions[2][1] = width - pos[0];
      }else if(i == 2){
        newHoseiPositions[3][0] = height - (height - pos[1]);
        newHoseiPositions[3][1] = width - pos[0];
      }else if(i == 3){
        newHoseiPositions[0][0] = pos[1];
        newHoseiPositions[0][1] = width - pos[0];
      }
    }else{
      if(i == 0){
        newHoseiPositions[3][0] = height - pos[1];
        newHoseiPositions[3][1] = pos[0];
      }else if(i == 1){
        newHoseiPositions[0][0] = height - pos[1];
        newHoseiPositions[0][1] = pos[0];
      }else if(i == 2){
        newHoseiPositions[1][0] = height - pos[1];
        newHoseiPositions[1][1] = pos[0];
      }else if(i == 3){
        newHoseiPositions[2][0] = height - pos[1];
        newHoseiPositions[2][1] = pos[0];
      }
    }
  });

  return newHoseiPositions;
}